import { useMemo } from 'react';
import { capitalizeFirst } from '@sendible/common';
import { useBridgeUser } from '@sendible/shared-state-bridge';
import { Bar, Container, Graph } from './index.styles';
import { formatWeekRange } from '../../utils';

interface Props {
  isHighlighted?: boolean;
  onClick?: () => void;
  postsPerDays: [number, number, number, number, number, number, number];
  weekEnd: CalendarMonthString;
  weekStart: CalendarMonthString;
}

export const WeekCard = ({ isHighlighted, onClick, postsPerDays, weekEnd, weekStart }: Props) => {
  const user = useBridgeUser();

  const max = Math.max(...postsPerDays);
  const safeMax = max > 0 ? max : 1;
  const label = useMemo(() => formatWeekRange(weekStart, weekEnd, user?.language), [weekStart, weekEnd, user?.language]);

  return (
    <Container
      data-testid="posts-per-week-container"
      $isHighlighted={!!isHighlighted}
      onClick={onClick}
    >
      <p data-testid="posts-per-week-data-range">{capitalizeFirst(label)}</p>
      <Graph data-testid="posts-per-week-graph">
        {postsPerDays.map((count, idx) => {
          const zero = count === 0;
          const pct = zero ? 0 : (count / safeMax) * 100;

          return (
            <Bar
              data-testid="posts-per-day-bar"
              aria-label={`Day ${idx + 1} has ${count} post${count === 1 ? '' : 's'}`}
              $height={zero ? 1 : pct}
              $isZero={zero}
              key={idx}
              title={`${count} post${count === 1 ? '' : 's'}`}
            />
          );
        })}
      </Graph>
    </Container>
  );
};
